export default __webpack_public_path__ + "static/media/loool-logo.83cffe50.svg";